export default __webpack_public_path__ + "static/SRC YT25 - Product Specifications & Technical Data-89615da93fc51b242637a285d372173c.pdf";